import React from 'react';
import { HashLink } from 'react-router-hash-link';
import { useTranslation } from 'react-i18next';
import ig from '../images/ig.svg';

const Footer = () => {
  const { t } = useTranslation();

  const socials = [
    {
      href: t('contact.twitter'), label: 'X',
      icon: <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231 5.451-6.231zm-1.161 17.52h1.833L7.084 4.126H5.117l11.966 15.644z" />,
    },
    {
      href: t('contact.facebook'), label: 'Facebook',
      icon: <path d="M13.397 20.997v-8.196h2.765l.411-3.209h-3.176V7.548c0-.926.258-1.56 1.587-1.56h1.684V3.127A22.336 22.336 0 0 0 14.201 3c-2.444 0-4.122 1.492-4.122 4.231v2.355H7.332v3.209h2.753v8.202h3.312z" />,
    },
    {
      href: t('contact.linkedin'), label: 'LinkedIn',
      icon: <><circle cx="4.983" cy="5.009" r="2.188" /><path d="M9.237 8.855v12.139h3.769v-6.003c0-1.584.298-3.118 2.262-3.118 1.937 0 1.961 1.811 1.961 3.218v5.904H21v-6.657c0-3.27-.704-5.783-4.526-5.783-1.835 0-3.065 1.007-3.568 1.96h-.051v-1.66H9.237zm-6.142 0H6.87v12.139H3.095z" /></>,
    },
  ];

  return (
    <footer className="footer-surface text-slatex-400">
      <div className="container-x py-16">
        <div className="grid gap-10 lg:grid-cols-12">
          {/* Brand */}
          <div className="lg:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-gradient-to-br from-brand-500 to-brand-700">
                <svg className="h-5 w-5 text-white" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M8 6 3 12l5 6" /><path d="m16 6 5 6-5 6" /></svg>
              </span>
              <span className="text-xl font-extrabold tracking-tight text-white font-display">
                kesnel<span className="text-brand-400">Digital</span>
              </span>
            </div>
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-slatex-400">
              {t('heroAbout.title')}
            </p>
            <div className="mt-6 flex items-center gap-2 text-sm text-slatex-400">
              <svg className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M21 10c0 7-9 12-9 12s-9-5-9-12a9 9 0 0 1 18 0Z" /><circle cx="12" cy="10" r="3" /></svg>
              {t('footer.address.line1')}, {t('footer.address.line2')}
            </div>
          </div>

          {/* Links */}
          <div className="lg:col-span-3">
            <h4 className="text-sm font-semibold uppercase tracking-wider text-white">{t('footer.links')}</h4>
            <ul className="mt-4 space-y-3 text-sm">
              <li><HashLink to="/about" className="hover:text-white transition">{t('footer.about')}</HashLink></li>
              <li><HashLink to="/services" className="hover:text-white transition">{t('footer.services')}</HashLink></li>
              <li><HashLink to="/portefolio" className="hover:text-white transition">{t('navbar.portfolio')}</HashLink></li>
              <li><HashLink to="/contact" className="hover:text-white transition">{t('footer.contact')}</HashLink></li>
            </ul>
          </div>

          {/* Services */}
          <div className="lg:col-span-4">
            <h4 className="text-sm font-semibold uppercase tracking-wider text-white">{t('footer.ourServices')}</h4>
            <ul className="mt-4 space-y-3 text-sm">
              <li>{t('footer.webDevelopment')}</li>
              <li>{t('footer.mobileAppDevelopment')}</li>
              <li>{t('footer.domainHosting')}</li>
              <li>{t('footer.itConsultations')}</li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-12 flex flex-col sm:flex-row items-center justify-between gap-6 border-t border-white/10 pt-8">
          <p className="text-xs text-slatex-400">
            © {new Date().getFullYear()} kesnelDigital. {t('footer.allRightsReserved')}
          </p>
          <div className="flex items-center gap-3">
            {socials.map((s) => (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="noreferrer"
                aria-label={s.label}
                className="flex h-9 w-9 items-center justify-center rounded-full border border-white/10 bg-white/5 text-slatex-400 transition hover:bg-white hover:text-ink"
              >
                <svg className="h-5 w-5 fill-current" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">{s.icon}</svg>
              </a>
            ))}
            <a
              href={t('contact.instagram')}
              target="_blank"
              rel="noreferrer"
              aria-label="Instagram"
              className="flex h-9 w-9 items-center justify-center rounded-full border border-white/10 bg-white/5 transition hover:bg-white"
            >
              <img alt="Instagram" className="h-4 w-4" src={ig} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
